// components/ProtectedRoute/index.jsx
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Context } from '../context/Contex';

export default function ProtectedRoute({
    children,
    resource,
    redirectTo = "/"
}) {
    const {
        permissions,
        permissionsLoading,
        hasPermission,
        authenticated
    } = useContext(Context);

    // Se não estiver autenticado, redireciona para login
    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    // Mostra loading enquanto carrega permissões
    if (permissionsLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '1.2rem',
                color: '#666',
                flexDirection: 'column',
                gap: '1rem'
            }}>
                <div className="spinner" style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <div>Verificando permissões...</div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // Se não tem a permissão necessária, redireciona
    if (resource && !hasPermission(resource)) {
        console.warn(`⚠️ Acesso negado: usuário não tem permissão para "${resource}"`);
        return <Navigate to={redirectTo} replace />;
    }

    // Tem permissão, renderiza o componente
    return children;
}


export function PermissionGuard({ children, resource, fallback = null }) {
    const { hasPermission } = useContext(Context);

    if (!resource || !hasPermission(resource)) {
        return fallback;
    }

    return children;
}